import { ApiError } from '../../../api/client';

// PARA-131 (AD-1, AC-15) — распознавание отказа по квоте задач.
// `JSON.parse(error.message)` запрещён: тело ошибки приходит разобранным в
// ApiError.body (shared/api-client), а разбор строки в компонентах хрупок.

/** Лимит задач из тела 402 (`{ detail, task_limit }`, PARA-119) либо null,
 * если ошибка не про квоту или тело не соответствует ожидаемой форме. */
export function getTaskLimit(error: unknown): number | null {
  if (!(error instanceof ApiError) || error.status !== 402) {
    return null;
  }
  const body = error.body;
  if (typeof body !== 'object' || body === null) {
    return null;
  }
  const taskLimit = (body as { task_limit?: unknown }).task_limit;
  return typeof taskLimit === 'number' ? taskLimit : null;
}
